async function fetchProductRecommendations(locale, productId) {
  try {
    const response = await fetch(
      window.Shopify.routes.root +
        `recommendations/products.json?product_id=${productId}&section_id=product-recommendations&intent=related`
    );
    if (!response.ok) {
      throw new Error("Error al obtener recomendaciones");
    }
    const recommendations = await response.json();
    renderRecommendations(recommendations.products);
  } catch (error) {
    console.error("Fetch error:", error);
  }
}

function renderRecommendations(products) {
  const container = document.querySelector(".recommendations-pdp .container");
  if (!container) return;

  container.innerHTML = `
      <ul>
      ${products
        .map(
          (product) => `
          <li class="product-recomendation" id="${product.id}">
            <a href="${product.url}">
              <div class="content_image">
                <img src="${product.featured_image}" alt="${product.title}" loading="lazy" width="auto" height="auto">
              </div>
              <div class="content_bottom">
                <h3>${product.title}</h3>
                <p>${formatMoney(product.price)}</p>
              </div>
            </a>
          </li>
        `
        )
        .join("")}
    </ul>
  `;
}

function formatMoney(amount) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount / 100);
}
